export const LOCAL_PHOTOS = [
  '/brand/local-01.jpg',
  '/brand/local-02.jpg',
  '/brand/local-03.jpg',
  '/brand/local-05.jpg',
  '/brand/local-06.jpg',
  '/brand/local-07.jpg',
  '/brand/local-08.jpg',
  '/brand/local-09.jpg',
];

export const PRODUCT_PHOTOS = [
  '/brand/hero-bg.jpg',
  '/brand/pizza-muzza.jpg',
  '/brand/empanada-jamonyq.jpg',
  '/brand/tartine-jyq.jpg',
  '/brand/pizza-napo.jpg',
  '/brand/empanadas-clasicas.jpg',
  '/brand/tartine-verdu.jpg',
  '/brand/cafe.jpg',
  '/brand/hamburguesa.jpg',
  '/brand/slider.jpg',
];

export const DEFAULT_BRAND_IMAGES = {
  logo: '/brand/logo-oficial.png',
  heroInicio: '/brand/local-01.jpg',
  heroComoFunciona: '/brand/local-08.jpg',
  heroBeneficios: '/brand/pizza-muzza.jpg',
  heroCanjes: '/brand/slider.jpg',
  heroSucursales: '/brand/local-03.jpg',
  heroAyuda: '/brand/local-05.jpg',
  bannerClub: '/brand/club-desktop.jpg',
  destacado1: '/brand/hero-bg.jpg',
  destacado2: '/brand/pizza-muzza.jpg',
  destacado3: '/brand/empanada-jamonyq.jpg',
  destacado4: '/brand/tartine-jyq.jpg',
  destacado5: '/brand/empanadas-clasicas.jpg',
  destacado6: '/brand/local-09.jpg',
  ayudaConsejo1: '/brand/pizza.jpg',
  ayudaConsejo2: '/brand/tartine-jyq.jpg',
  ayudaConsejo3: '/brand/local-02.jpg',
};

export const BRAND_LIBRARY = [
  { src: '/brand/logo-oficial.png', label: 'Logo oficial' },
  { src: '/brand/club-desktop.jpg', label: 'Banner club' },
  { src: '/brand/hero-bg.jpg', label: 'Interior del local' },
  { src: '/brand/slider.jpg', label: 'Slider vacío a la provoleta' },
  { src: '/brand/local-01.jpg', label: 'Local 1' },
  { src: '/brand/local-02.jpg', label: 'Local 2' },
  { src: '/brand/local-03.jpg', label: 'Local 3' },
  { src: '/brand/local-05.jpg', label: 'Local 5' },
  { src: '/brand/local-06.jpg', label: 'Local 6' },
  { src: '/brand/local-07.jpg', label: 'Local 7' },
  { src: '/brand/local-08.jpg', label: 'Local 8' },
  { src: '/brand/local-09.jpg', label: 'Local 9' },
  { src: '/brand/pizza-muzza.jpg', label: 'Pizza muzzarella' },
  { src: '/brand/pizza-napo.jpg', label: 'Pizza napolitana' },
  { src: '/brand/pizza.jpg', label: 'Pizza' },
  { src: '/brand/empanada-jamonyq.jpg', label: 'Empanada jamón y queso' },
  { src: '/brand/empanadas-clasicas.jpg', label: 'Empanadas clásicas' },
  { src: '/brand/tartine-jyq.jpg', label: 'Tartine jamón y queso' },
  { src: '/brand/tartine-verdu.jpg', label: 'Tartine verdura' },
  { src: '/brand/hamburguesa.jpg', label: 'Hamburguesa' },
  { src: '/brand/cafe.jpg', label: 'Café' },
];

export const BRAND_IMAGE_GROUPS = [
  {
    id: 'marca',
    title: 'Marca',
    items: ['logo', 'bannerClub'],
  },
  {
    id: 'heroes',
    title: 'Fotos de portada',
    items: ['heroInicio', 'heroComoFunciona', 'heroBeneficios', 'heroCanjes', 'heroAyuda'],
  },
  {
    id: 'destacados',
    title: 'Beneficios destacados del inicio',
    items: ['destacado1', 'destacado2', 'destacado3', 'destacado4', 'destacado5', 'destacado6'],
  },
  {
    id: 'ayuda',
    title: 'Ayuda',
    items: ['ayudaConsejo1', 'ayudaConsejo2', 'ayudaConsejo3'],
  },
];

export const BRAND_IMAGE_FIELDS = [
  { key: 'logo', label: 'Logo del header' },
  { key: 'heroInicio', label: 'Foto de portada — Inicio' },
  { key: 'heroComoFunciona', label: 'Foto de portada — Cómo funciona' },
  { key: 'heroBeneficios', label: 'Foto de portada — Beneficios' },
  { key: 'heroCanjes', label: 'Foto de portada — Canjes' },
  { key: 'heroAyuda', label: 'Foto de portada — Ayuda' },
  { key: 'bannerClub', label: 'Banner Club de Beneficios' },
  { key: 'destacado1', label: 'Destacado 1 — Martes de empanadas' },
  { key: 'destacado2', label: 'Destacado 2 — Cumple' },
  { key: 'destacado3', label: 'Destacado 3 — Premios por puntos' },
  { key: 'destacado4', label: 'Destacado 4 — Promos exclusivas' },
  { key: 'destacado5', label: 'Destacado 5 — Vouchers' },
  { key: 'destacado6', label: 'Destacado 6 — Momentos' },
  { key: 'ayudaConsejo1', label: 'Ayuda — consejo 1' },
  { key: 'ayudaConsejo2', label: 'Ayuda — consejo 2' },
  { key: 'ayudaConsejo3', label: 'Ayuda — consejo 3' },
];

export function getBrandImage(config, key) {
  const override = config?.imagenesSitio?.[key];
  if (override && String(override).trim()) return String(override).trim();
  return DEFAULT_BRAND_IMAGES[key] || '';
}

export function getLocalPhoto(index = 0) {
  return LOCAL_PHOTOS[index % LOCAL_PHOTOS.length];
}

export function getProductPhoto(index = 0) {
  return PRODUCT_PHOTOS[index % PRODUCT_PHOTOS.length];
}
